import { trustHTML } from "@ember/template";
import { i18n } from "discourse-i18n";
import CircleDeleteButton from "../../../components/circles/delete-button";
import CircleManageOwnershipButton from "../../../components/circles/manage-ownership-button";

const CircleManageAdvanced = <template>
  <section
    class="circles-manage-advanced-section circles-manage-transfer-ownership"
  >
    <h2>
      {{i18n "discourse_circles.circle.manage.advanced.ownership.title"}}
    </h2>
    <p>
      {{i18n
        "discourse_circles.circle.manage.advanced.ownership.add.disclaimer"
      }}
    </p>
    <CircleManageOwnershipButton @model={{@model}} @mode="add" />

    <p>
      {{i18n
        "discourse_circles.circle.manage.advanced.ownership.remove.disclaimer"
      }}
    </p>
    <CircleManageOwnershipButton @model={{@model}} @mode="remove" />

    <p>
      {{i18n
        "discourse_circles.circle.manage.advanced.ownership.transfer.disclaimer"
      }}
    </p>
    <CircleManageOwnershipButton @model={{@model}} @mode="transfer" />
  </section>

  <section class="circles-manage-advanced-section circles-manage-delete-circle">
    <h2>
      {{i18n "discourse_circles.circle.manage.advanced.delete.title"}}
    </h2>
    <p>
      {{trustHTML
        (i18n
          "discourse_circles.circle.manage.advanced.delete.disclaimer"
          name=@model.name
        )
      }}
    </p>
    <CircleDeleteButton @model={{@model}} />
  </section>
</template>;

export default CircleManageAdvanced;
